import React from "react";
import { HiArrowLeft } from "react-icons/hi2";
function BackButtonNew({ handleGoBack, children }) {
    return (
        <div className="hidden md:block">
            <button
                onClick={handleGoBack}
                className="p-1 rounded-full flex items-center justify-center font-bold gap-2 w-8 h-8"
                // style={{ height: "1.5rem" }}
            >
                <HiArrowLeft className="w-4 h-4" strokeWidth={0.5} /> {children}
            </button>
        </div>
    );
}

export default BackButtonNew;
